<template>
  <div class="plazza-reward-mask" v-if="visible" @click.self="close">
    <div class="reward-sheet" :class="{ show: sheetShow }">
      <div class="sheet-header">
        <span class="sheet-back" @click="close">
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="#fff"/>
          </svg>
        </span>
        <span class="sheet-title">打赏礼物</span>
      </div>

      <div class="gift-grid" v-loading="loading">
        <div
          class="gift-item"
          v-for="gift in giftList"
          :key="gift.id"
          :class="{ active: selectedGiftId === gift.id }"
          @click="selectGift(gift)"
        >
          <div class="gift-icon-wrap">
            <img :src="$imgUrl(gift.icon)" class="gift-icon" />
          </div>
          <div class="gift-name">{{ gift.name }}</div>
          <div class="gift-price-wrap" :class="{ active: selectedGiftId === gift.id }">
            <span class="gift-price">{{ gift.price }}</span>
          </div>
          <div class="gift-send" v-if="selectedGiftId === gift.id">赠送</div>
        </div>
      </div>
      <div class="gift-empty" v-if="!loading && giftList.length === 0">
        暂无可打赏的礼物
      </div>

      <div class="sheet-footer">
        <div class="qty-box" ref="qtyBox" @click.stop>
          <span class="qty-label">数量</span>
          <div class="qty-select" :class="{ open: qtyDropdownOpen }" @click="qtyDropdownOpen = !qtyDropdownOpen">
            <span class="qty-value">{{ qty }}</span>
            <svg class="qty-arrow" :class="{ up: qtyDropdownOpen }" width="12" height="12" viewBox="0 0 12 12">
              <path d="M6 8L2 4h8z" fill="#d1ae52"/>
            </svg>
          </div>
          <div class="qty-dropdown" v-if="qtyDropdownOpen">
            <div
              class="qty-option"
              v-for="opt in qtyOptions"
              :key="opt"
              :class="{ active: qty === opt }"
              @click="selectQty(opt)"
            >{{ opt }}</div>
          </div>
        </div>
        <div class="confirm-btn" :class="{ disabled: !selectedGiftId || submitting }" @click="handleConfirm">
          {{ submitting ? '打赏中...' : '确认' }}
        </div>
      </div>
    </div>
    <PasswordPopup v-if="passwordPopupVisible" :visible="passwordPopupVisible" @submit="onPasswordSubmit" @close="closePasswordPopup" />
  </div>
</template>

<script>
import PasswordPopup from './view/withdraw/PasswordPopup.vue';
export default {
  name: 'PlazzaRewardModal',
  components: { PasswordPopup },
  props: {
    visible: { type: Boolean, default: false },
    post: { type: Object, default: null },
  },
  data() {
    return {
      sheetShow: false,
      giftList: [],
      loading: false,
      selectedGiftId: null,
      qty: 1,
      submitting: false,
      qtyDropdownOpen: false,
      qtyOptions: [100, 50, 20, 10, 5, 2, 1],
      passwordPopupVisible: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => { this.sheetShow = true; });
        this.resetState();
        this.loadGifts();
        document.addEventListener('click', this.handleClickOutside);
      } else {
        this.sheetShow = false;
        this.qtyDropdownOpen = false;
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
  },
  methods: {
    resetState() {
      this.selectedGiftId = null;
      this.qty = 1;
      this.submitting = false;
    },
    loadGifts() {
      if (this.giftList.length > 0) {
        this.selectedGiftId = this.giftList[0].id;
        return;
      }
      this.loading = true;
      this.$apiFun.post('/api/plazza/gifts').then(res => {
        if (res.code === 200) {
          this.giftList = res.data || [];
          if (this.giftList.length > 0) {
            this.selectedGiftId = this.giftList[0].id;
          }
        }
      }).catch(e => {
        console.error('加载礼物失败', e);
      }).then(() => {
        this.loading = false;
      });
    },
    selectGift(gift) {
      this.selectedGiftId = gift.id;
    },
    selectQty(opt) {
      this.qty = opt;
      this.qtyDropdownOpen = false;
    },
    handleClickOutside(e) {
      if (this.qtyDropdownOpen && this.$refs.qtyBox && !this.$refs.qtyBox.contains(e.target)) {
        this.qtyDropdownOpen = false;
      }
    },
    close() {
      this.sheetShow = false;
      setTimeout(() => {
        this.$emit('update:visible', false);
        this.$emit('close');
      }, 260);
    },
    handleConfirm() {
      if (!this.selectedGiftId) {
        this.$toast('请选择礼物');
        return;
      }
      if (!this.post || !this.post.id) {
        this.$toast('缺少帖子信息');
        return;
      }
      if (this.submitting) return;
      this.passwordPopupVisible = true;
    },
    closePasswordPopup() {
      this.passwordPopupVisible = false;
    },
    onPasswordSubmit(password) {
      this.passwordPopupVisible = false;
      this.submitting = true;
      this.$apiFun.post('/api/plazza/post/reward', {
        post_id: this.post.id,
        gift_id: this.selectedGiftId,
        gift_count: this.qty,
        password: password,
      }).then(res => {
        if (res.code === 200) {
          this.$toast('打赏成功');
          this.$emit('success', res.data || {});
          this.close();
        } else {
          this.$toast((res && res.message) || (res && res.msg) || '打赏失败');
        }
      }).catch(e => {
        console.error('打赏失败', e);
        this.$toast('打赏失败');
      }).then(() => {
        this.submitting = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.plazza-reward-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.reward-sheet {
  width: 100%;
  background: #1a1a1a;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  padding: 0.3rem 0.3rem calc(0.3rem + env(safe-area-inset-bottom));
  transform: translateY(100%);
  transition: transform 0.26s ease-out;
  max-height: 85vh;
  overflow-y: auto;

  &.show {
    transform: translateY(0);
  }

  .sheet-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.45rem;
    padding: 0.2rem 0;

    .sheet-back {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:active {
        opacity: 0.7;
      }
    }

    .sheet-title {
      font-size: 0.36rem;
      color: #fff;
      font-weight: 500;
    }
  }

  .gift-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.2rem;
    margin-bottom: 0.5rem;

    .gift-item {
      background: #1a1a1a;
      border: 1px solid #333333;
      border-radius: 0.15rem;
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      transition: border-color 0.2s, background 0.2s;
      position: relative;

      &:active {
        opacity: 0.8;
      }

      .gift-icon-wrap {
        width: 0.95rem;
        height: 0.95rem;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin-bottom: 0.15rem;

        .gift-icon {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border: none;
          border-radius: 0;
        }
      }

      .gift-name {
        font-size: 0.32rem;
        color: #fff;
        margin-bottom: 0.08rem;
      }

      .gift-price-wrap {
        display: flex;
        justify-content: center;

        .gift-price {
          font-size: 0.28rem;
          color: #666;
        }

        &.active .gift-price {
          color: #fff;
          font-size: 0.32rem;
          font-weight: bold;
        }
      }

      .gift-send {
        width: 100%;
        font-size: 0.32rem;
        color: #703904;
        background: #d1ae52;
        padding: 0.04rem 0;
        border-radius: 0 0 0.12rem 0.12rem;
        margin-top: 0.08rem;
        line-height: 1.4;
        text-align: center;
      }

      &.active {
        border: 1px solid #d1ae52;

        .gift-name {
          display: none;
        }
      }
    }
  }

  .gift-empty {
    text-align: center;
    padding: 1rem 0;
    color: #666;
    font-size: 0.3rem;
  }

  .sheet-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.3rem;
    position: relative;

    .qty-box {
      display: flex;
      align-items: center;
      gap: 0.15rem;
      background: #1a1a1a;
      border-radius: 0.4rem;
      padding: 0.12rem 0.2rem;
      position: relative;

      .qty-label {
        font-size: 0.28rem;
        color: #999;
      }

      .qty-select {
        display: flex;
        align-items: center;
        gap: 0.1rem;
        background: #1a1a1a;
        border: 1px solid #d1ae52;
        border-radius: 0.15rem;
        color: #fff;
        font-size: 0.28rem;
        padding: 0.2rem 0.35rem;
        cursor: pointer;
        user-select: none;

        .qty-value {
          min-width: 0.4rem;
          text-align: center;
        }

        .qty-arrow {
          transition: transform 0.2s;

          &.up {
            transform: rotate(180deg);
          }
        }

        &.open .qty-arrow {
          transform: rotate(180deg);
        }
      }

      .qty-dropdown {
        position: absolute;
        bottom: calc(100% + 0.1rem);
        left: 0.8rem;
        width: 1.65rem;
        background: #1a1a1a;
        border: 1px solid #333;
        border-radius: 0.15rem;
        z-index: 999;
        overflow: hidden;

        .qty-option {
          padding: 0.25rem 0.2rem;
          font-size: 0.32rem;
          color: #666;
          text-align: center;
          cursor: pointer;

          &:hover {
            background: #2a2a2a;
          }

          &.active {
            color: #d1ae52;
          }
        }
      }
    }

    .confirm-btn {
      flex: 1;
      height: 0.88rem;
      border-radius: 0.24rem;
      background: #d1ae52;
      color: #703904;
      font-size: 0.35rem;
      font-weight: 500;
      letter-spacing: 0.05rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:active {
        opacity: 0.85;
      }

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PlazzaRewardModal.vue